import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid, IconButton } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

import useStyles from './makeStyles';

const MemberPromoCode = ({
  policyNumber,
  setShowPromoInput,
  removeAppliedPromoCode,
}) => {
  const classes = useStyles();

  const editShowPromoInput = useCallback(() => {
    setShowPromoInput(true);
  }, [setShowPromoInput]);

  return (
    <Grid container justifyContent="flex-end" spacing={1}>
      <Grid className={classes.promoCode}>
        <Grid item>
          <Typography component="div" className={classes.policyNumber} onClick={editShowPromoInput}>
            {policyNumber}
          </Typography>
        </Grid>
        <Grid item>
          <IconButton
            className={classes.iconButton}
            onClick={removeAppliedPromoCode}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Grid>

      </Grid>
    </Grid>
  );
};

MemberPromoCode.propTypes = {
  policyNumber: PropTypes.string.isRequired,
  setShowPromoInput: PropTypes.func.isRequired,
  removeAppliedPromoCode: PropTypes.func.isRequired,
};

export default MemberPromoCode;
